// Get Purchase List Action Type

export const GET_PURCHASE_LIST = "GET_PURCHASE_LIST";
export const GET_PURCHASE_LIST_SUCCESS = "GET_PURCHASE_LIST_SUCCESS";
export const GET_PURCHASE_LIST_FAILURE = "GET_PURCHASE_LIST_FAILURE";

// Get Single Purchase Action Type

export const GET_SINGLE_PURCHASE = "GET_SINGLE_PURCHASE";
export const GET_SINGLE_PURCHASE_SUCCESS = "GET_SINGLE_PURCHASE_SUCCESS";
export const GET_SINGLE_PURCHASE_FAILURE = "GET_SINGLE_PURCHASE_FAILURE";

// Create Single Purchase Action Type

export const CREATE_SINGLE_PURCHASE = "CREATE_SINGLE_PURCHASE";
export const CREATE_SINGLE_PURCHASE_SUCCESS = "CREATE_SINGLE_PURCHASE_SUCCESS";
export const CREATE_SINGLE_PURCHASE_FAILURE = "CREATE_SINGLE_PURCHASE_FAILURE";

// Update Single Purchase Action Type

export const UPDATE_SINGLE_PURCHASE = "UPDATE_SINGLE_PURCHASE";
export const UPDATE_SINGLE_PURCHASE_SUCCESS = "UPDATE_SINGLE_PURCHASE_SUCCESS";
export const UPDATE_SINGLE_PURCHASE_FAILURE = "UPDATE_SINGLE_PURCHASE_FAILURE";

// Purchase Status List Action Type

export const GET_PURCHASE_STATUS_LIST = "GET_PURCHASE_STATUS_LIST";
export const GET_PURCHASE_STATUS_LIST_SUCCESS =
  "GET_PURCHASE_STATUS_LIST_SUCCESS";
export const GET_PURCHASE_STATUS_LIST_FAILURE =
  "GET_PURCHASE_STATUS_LIST_FAILURE";

// Single Supplier Purchase List Action Type

export const SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST =
  "SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST";
export const SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_SUCCESS =
  "SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_SUCCESS";
export const SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_FAILURE =
  "SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_FAILURE";

// Purchase Item Category List

export const GET_PURCHASE_ITEM_CATEGORY_LIST =
  "GET_PURCHASE_ITEM_CATEGORY_LIST";
export const GET_PURCHASE_ITEM_CATEGORY_LIST_SUCCESS =
  "GET_PURCHASE_ITEM_CATEGORY_LIST_SUCCESS";
export const GET_PURCHASE_ITEM_CATEGORY_LIST_FAILURE =
  "GET_PURCHASE_ITEM_CATEGORY_LIST_FAILURE";

// Purchase Item Search by Job Id Action Type

export const SEARCH_PURCHASE_ITEM_BY_JOB_ID = "SEARCH_PURCHASE_ITEM_BY_JOB_ID";
export const SEARCH_PURCHASE_ITEM_BY_JOB_ID_SUCCESS =
  "SEARCH_PURCHASE_ITEM_BY_JOB_ID_SUCCESS";
export const SEARCH_PURCHASE_ITEM_BY_JOB_ID_FAILURE =
  "SEARCH_PURCHASE_ITEM_BY_JOB_ID_FAILURE";

// Convert Purchase Item To Billable / Unlink / Mark Billed Action Types

export const CONVERT_PURCHASE_ITEM_TO_BILLABLE =
  "CONVERT_PURCHASE_ITEM_TO_BILLABLE";
export const CONVERT_PURCHASE_ITEM_TO_BILLABLE_SUCCESS =
  "CONVERT_PURCHASE_ITEM_TO_BILLABLE_SUCCESS";
export const CONVERT_PURCHASE_ITEM_TO_BILLABLE_FAILURE =
  "CONVERT_PURCHASE_ITEM_TO_BILLABLE_FAILURE";

export const UNLINK_PURCHASE_ITEM_BILLABLE = "UNLINK_PURCHASE_ITEM_BILLABLE";
export const UNLINK_PURCHASE_ITEM_BILLABLE_SUCCESS =
  "UNLINK_PURCHASE_ITEM_BILLABLE_SUCCESS";
export const UNLINK_PURCHASE_ITEM_BILLABLE_FAILURE =
  "UNLINK_PURCHASE_ITEM_BILLABLE_FAILURE";

export const MARK_PURCHASE_ITEM_BILLED = "MARK_PURCHASE_ITEM_BILLED";
export const MARK_PURCHASE_ITEM_BILLED_SUCCESS =
  "MARK_PURCHASE_ITEM_BILLED_SUCCESS";
export const MARK_PURCHASE_ITEM_BILLED_FAILURE =
  "MARK_PURCHASE_ITEM_BILLED_FAILURE";

export const MARK_PURCHASE_ITEM_IGNORED = "MARK_PURCHASE_ITEM_IGNORED";
export const MARK_PURCHASE_ITEM_IGNORED_SUCCESS =
  "MARK_PURCHASE_ITEM_IGNORED_SUCCESS";
export const MARK_PURCHASE_ITEM_IGNORED_FAILURE =
  "MARK_PURCHASE_ITEM_IGNORED_FAILURE";

// Add New Purchase Status
export const ADD_NEW_PURCHASE_STATUS = "ADD_NEW_PURCHASE_STATUS";
export const ADD_NEW_PURCHASE_STATUS_SUCCESS =
  "ADD_NEW_PURCHASE_STATUS_SUCCESS";
export const ADD_NEW_PURCHASE_STATUS_FAILURE =
  "ADD_NEW_PURCHASE_STATUS_FAILURE";

// Delete Purchase Status
export const DELETE_PURCHASE_STATUS = "DELETE_PURCHASE_STATUS";
export const DELETE_PURCHASE_STATUS_SUCCESS = "DELETE_PURCHASE_STATUS_SUCCESS";
export const DELETE_PURCHASE_STATUS_FAILURE = "DELETE_PURCHASE_STATUS_FAILURE";

// Update Purchase Status
export const UPDATE_PURCHASE_STATUS = "UPDATE_PURCHASE_STATUS";
export const UPDATE_PURCHASE_STATUS_SUCCESS = "UPDATE_PURCHASE_STATUS_SUCCESS";
export const UPDATE_PURCHASE_STATUS_FAILURE = "UPDATE_PURCHASE_STATUS_FAILURE";

// Add New Purchase Item Category
export const ADD_NEW_PURCHASE_ITEM_CATEGORY = "ADD_NEW_PURCHASE_ITEM_CATEGORY";
export const ADD_NEW_PURCHASE_ITEM_CATEGORY_SUCCESS =
  "ADD_NEW_PURCHASE_ITEM_CATEGORY_SUCCESS";
export const ADD_NEW_PURCHASE_ITEM_CATEGORY_FAILURE =
  "ADD_NEW_PURCHASE_ITEM_CATEGORY_FAILURE";

// Delete Purchase Item Category
export const DELETE_PURCHASE_ITEM_CATEGORY = "DELETE_PURCHASE_ITEM_CATEGORY";
export const DELETE_PURCHASE_ITEM_CATEGORY_SUCCESS =
  "DELETE_PURCHASE_ITEM_CATEGORY_SUCCESS";
export const DELETE_PURCHASE_ITEM_CATEGORY_FAILURE =
  "DELETE_PURCHASE_ITEM_CATEGORY_FAILURE";

// Update Purchase Item Category
export const UPDATE_PURCHASE_ITEM_CATEGORY = "UPDATE_PURCHASE_ITEM_CATEGORY";
export const UPDATE_PURCHASE_ITEM_CATEGORY_SUCCESS =
  "UPDATE_PURCHASE_ITEM_CATEGORY_SUCCESS";
export const UPDATE_PURCHASE_ITEM_CATEGORY_FAILURE =
  "UPDATE_PURCHASE_ITEM_CATEGORY_FAILURE";

// Delete Single Purchase
export const DELETE_SINGLE_PURCHASE = "DELETE_SINGLE_PURCHASE";
export const DELETE_SINGLE_PURCHASE_SUCCESS = "DELETE_SINGLE_PURCHASE_SUCCESS";
export const DELETE_SINGLE_PURCHASE_FAILURE = "DELETE_SINGLE_PURCHASE_FAILURE";

///purchaseitem/search
// Search Purchase Item List
export const SEARCH_PURCHASE_ITEM_LIST = "SEARCH_PURCHASE_ITEM_LIST";
export const SEARCH_PURCHASE_ITEM_LIST_SUCCESS =
  "SEARCH_PURCHASE_ITEM_LIST_SUCCESS";
export const SEARCH_PURCHASE_ITEM_LIST_FAILURE =
  "SEARCH_PURCHASE_ITEM_LIST_FAILURE";

///purchasedraft/upload
// Upload Purchase Draft
export const UPLOAD_PURCHASE_DRAFT = "UPLOAD_PURCHASE_DRAFT";
export const UPLOAD_PURCHASE_DRAFT_SUCCESS = "UPLOAD_PURCHASE_DRAFT_SUCCESS";
export const UPLOAD_PURCHASE_DRAFT_FAILURE = "UPLOAD_PURCHASE_DRAFT_FAILURE";
///fileattachment/create
// Create File Attachment
export const CREATE_FILE_ATTACHMENT = "CREATE_FILE_ATTACHMENT";
export const CREATE_FILE_ATTACHMENT_SUCCESS = "CREATE_FILE_ATTACHMENT_SUCCESS";
export const CREATE_FILE_ATTACHMENT_FAILURE = "CREATE_FILE_ATTACHMENT_FAILURE";
///purchaseattachment/search
// Search Purchase Attachment
export const SEARCH_PURCHASE_ATTACHMENT = "SEARCH_PURCHASE_ATTACHMENT";
export const SEARCH_PURCHASE_ATTACHMENT_SUCCESS =
  "SEARCH_PURCHASE_ATTACHMENT_SUCCESS";
export const SEARCH_PURCHASE_ATTACHMENT_FAILURE =
  "SEARCH_PURCHASE_ATTACHMENT_FAILURE";
///jobattachment/delete
// Delete Job Attachment
export const DELETE_JOB_ATTACHMENT = "DELETE_JOB_ATTACHMENT";
export const DELETE_JOB_ATTACHMENT_SUCCESS = "DELETE_JOB_ATTACHMENT_SUCCESS";
export const DELETE_JOB_ATTACHMENT_FAILURE = "DELETE_JOB_ATTACHMENT_FAILURE";

// Predict Transaction Financial
export const PREDICT_TRANSACTION_FINANCIAL = "PREDICT_TRANSACTION_FINANCIAL";
export const PREDICT_TRANSACTION_FINANCIAL_SUCCESS =
  "PREDICT_TRANSACTION_FINANCIAL_SUCCESS";
export const PREDICT_TRANSACTION_FINANCIAL_FAILURE =
  "PREDICT_TRANSACTION_FINANCIAL_FAILURE";
